import { render } from "./SignInModal.vue?vue&type=template&id=5f64c1a4&scoped=true&ts=true&lang=pug"
import script from "./SignInModal.vue?vue&type=script&lang=ts"
export * from "./SignInModal.vue?vue&type=script&lang=ts"

import "./SignInModal.vue?vue&type=style&index=0&id=5f64c1a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f64c1a4"]])

export default __exports__